import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransactionType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCreateTransactionType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (transactionTypeData: Partial<TransactionType>) => {
      await apiClient.transactionType.createTransactionType.mutation({ body: transactionTypeData });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-types'] });
      toast.success('Transaction type created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating transaction type!');
    },
  });
};
